import { createContext, useContext } from 'react';
/**
 * The reporter seam, in its own module rather than in `ApiProvider` — where it is
 * PROVIDED — so that a leaf component can consume it without importing the
 * provider. `VoiceClipPlayer` is the first consumer, and an import from there to
 * `ApiProvider` would pull `@agnivo/api-client`, the mock transport and the
 * conversation directory into a media component's module graph to reach one
 * `createContext` call.
 *
 * Default is a no-op, deliberately, and it is the one context in app-core that
 * gets one: `useApi` throws outside its provider because a screen without an API
 * is a composition bug worth failing loudly on. Telemetry is the opposite — it is
 * the subsystem whose absence must never break the surface it observes, and an
 * isolated component test should not have to mount a provider to render.
 *
 * ⚠️ The cost of that default is that a MISSING provider is indistinguishable
 * from a working one that dropped the event. Nothing in the app can tell them
 * apart, so the guard is a test that asserts the provider actually supplies a
 * non-default value — see `ApiProvider.clientEvent.test.tsx`.
 *
 * `NOOP_REPORT_CLIENT_EVENT` is exported (not an inline arrow) so a SECOND
 * provider mounted lower in the same tree — `AdminApiProvider`, when the
 * admin-tenant section is embedded inside a shell that already mounts
 * `ApiProvider` — can tell "no ambient provider yet" apart from "an ancestor
 * already provides a real reporter" by reference, and re-expose the ambient
 * value instead of minting a second, independently-budgeted reporter (architect
 * finding on web!614, 2026-09-12: nesting `AdminApiProvider` under a live
 * `ApiProvider` shadowed the budget rather than sharing it).
 */
export const NOOP_REPORT_CLIENT_EVENT = () => { };
export const ClientEventContext = createContext(NOOP_REPORT_CLIENT_EVENT);
export function useReportClientEvent() {
    return useContext(ClientEventContext);
}
//# sourceMappingURL=ClientEventContext.js.map